import React, { useContext, useState, useEffect } from 'react';
import { UserContext } from './UserContext';
import { PageContext } from './PageContext';
import { Container } from 'reactstrap';
import { Button, Toolbar } from '@progress/kendo-react-buttons';
import { Grid, GridColumn, GridColumnReorderEvent } from '@progress/kendo-react-grid';
import { MMGrid } from './DashboardGrid';
import { MMSubmissionForm } from './MMSubmissionForm';

interface dashCol{
    field:string,
    title:string,
    width:number,
    filter:boolean,
    format:string,
    minScreenWidth:number
}

interface dashboard{
    grid:string
    export:boolean
    columns:dashCol[]
}


export default function MediaMagic (){
    const userContext = useContext(UserContext);
    const pageContext = useContext(PageContext);
    
    const [dashCols, setDashCols] = useState<dashboard[]>([]);
    const user = userContext?.user;    
    const [showSubmit, setShowSubmit]= useState(false);

    async function getDashCols() {
        const userDir = "users/" + user?.username;
        const dashColsPath = userDir + "/dashCols.json";    
        await fetch(dashColsPath)
            .then((response) => response.json())
            .then((data) => setDashCols(data));
    }

    function getCols(grid:string){
        const cols=()=>dashCols.find(db=>db.grid===grid)?.columns || [];
        return (cols);
    }

    function getExport(grid:string){
        const exp=()=>dashCols.find(db=>db.grid===grid)?.export||false;
        return (exp);
    }

    const showSubmitForm=()=>{
        setShowSubmit(true);
    }

    const hideSumitForm=()=>{
        setShowSubmit(false);
    }

   
    const reorderColumn=(e:GridColumnReorderEvent)=>{
        console.log(e);
        // console.log(props.cols);
        // const newOrder = e.columns.sort((a,b)=>(a.orderIndex ?? 0)-(b.orderIndex ?? 0));
        // console.log(newOrder);
        // var newCols:dashCol[]=[];
        // newOrder.forEach((col)=>{
        //     const foundCol = props.cols.find((dc) => dc.field === col.field);
        //     if (foundCol) {
        //         newCols.push(foundCol);
        //     }
        // })
        // console.log(newCols);
        // switch (props.id){
        //     case "Dashboard1":
        //         pageContext?.
        // }
    }

    useEffect(() => {   
        if (user?.loggedIn){         
            getDashCols().then(data=>pageContext?.setShowLoading(false));
        }else{
            window.location.replace("/Login");
        }
    }, []);

    return (
        <>
        {user?.loggedIn ?
        <Container fluid>       
            <h2>Image Toning Jobs</h2>
            <Toolbar>
                <Button onClick={showSubmitForm}>+ New Request</Button>
            </Toolbar>
            <MMGrid cols={getCols("MediaMagic")()} id="MM" statuses='' export={getExport("MediaMagic")()} reorderCols={reorderColumn}/>                           
        </Container>
        : <></>}
        {showSubmit==true? <MMSubmissionForm title='New Toning Request' type="" onClose={hideSumitForm}/>:null}
        </>
    );
}